import AddIcon from "@mui/icons-material/Add";
import {Tooltip} from "@mui/material";
import IconButton from '@mui/material/IconButton';
import React, {type FC} from 'react';
import {useMatch, useParams} from "react-router";

import BasicTitle from './BasicTitle.js';
import {useUser, useUsers} from '../../api/index.js';
import {useCheckPermissions} from '../../auth/index.js';
import useDialogControls from '../../hooks/use-dialog-controls.js';
import type {Monitor} from '../../models/index.js';
import AddMonitorForm from '../Monitors/AddMonitorForm.js';


interface MonitorsBarContentProps {
  isUpating?: boolean;
}
const MonitorsBarContent: FC<MonitorsBarContentProps> = (isUpdating) => {
  const { canManageUsers } = useCheckPermissions();
  const {refetch} = useUsers();
  const { id = '' } = useParams();
  const URLMatch = useMatch(`/monitors/${id}`);
  const {data: monitor} = useUser(id as string, {enabled: !!id});

  const {
    open: formOpen,
    reset: resetForm,
    setOpen: setFormOpen,
  } = useDialogControls<Monitor>([]);


  return (
    <>
      <BasicTitle text={isUpdating && URLMatch ? monitor?.name as string : 'Monitors'} />
      {canManageUsers ? (
        <Tooltip arrow color="primary" placement="bottom" title={'Add a new monitor'}>
          <IconButton
            color="inherit"
            aria-label="add new monitor"
            onClick={() => setFormOpen(true)}
            edge="start"
            sx={{
              marginLeft: 'auto',
            }}
          >
            <AddIcon />
          </IconButton>
        </Tooltip>
      ) : null}
      <AddMonitorForm open={formOpen} onClose={resetForm} refetch={refetch}/>
    </>
  );
};

export default MonitorsBarContent;
